import { createRoute } from '@tanstack/react-router'
import { authenticatedRoute } from './_authenticated'
import { BlockedUsers } from '@/pages/blocked-users'

export const blockedUsersRoute = createRoute({
  getParentRoute: () => authenticatedRoute,
  path: '/blocked-users',
  component: BlockedUsers,
})
